import { useCallback, useState } from 'react';
import { useParams } from 'react-router';
import { useGetEntity } from '../../hooks/use-entities';
import { ItemRecord } from '../../api/api-items';
import { EntityBrowser } from './components/entity-browser';
import { ItemBrowser } from './components/item-browser';
import { ItemViewSheet } from '../../components/item-editor/item-view-sheet';
import { Spinner } from '@@/ui/components';

export function BrowserPage() {
  const { entityId = 'root' } = useParams<{ entityId?: string }>();
  const [selectedItem, setSelectedItem] = useState<ItemRecord | null>(null);
  const [isItemSheetOpen, setIsItemSheetOpen] = useState(false);
  const { data: currentEntity, isLoading: isEntityLoading } = useGetEntity(entityId, {
    enabled: entityId !== 'root'
  });

  const handleItemNavigate = useCallback((item: ItemRecord) => {
    setSelectedItem(item);
    setIsItemSheetOpen(true);
  }, []);

  const handleCloseItemSheet = useCallback((open: boolean) => {
    setIsItemSheetOpen(open);
    if (!open) {
      setSelectedItem(null);
    }
  }, []);

  return (
    <div className='h-full bg-white flex flex-col'>
      <div className='mx-2 flex-1 flex flex-col relative'>
        <div className='flex flex-row gap-4 py-2 h-full'>
          <EntityBrowser entityId={entityId} />
          <div className='flex-1 flex flex-col gap-2 overflow-auto'>
            {isEntityLoading && (
              <div className='flex items-center justify-center h-full py-12'>
                <Spinner size='lg' className='stroke-1' />
              </div>
            )}
            <div className='flex-1 gap-4 flex flex-row h-full'>
              {currentEntity && entityId !== 'root' && (
                <div className='flex-1 w-full'>
                  <ItemBrowser entity={currentEntity} entityId={entityId} onNavigate={handleItemNavigate} />
                </div>
              )}
              {entityId === 'root' && (
                <div className='bg-slate-50 rounded-md flex items-center justify-center flex-1 text-slate-500 h-60'>
                  Select an Entity on your left to continue.
                </div>
              )}
            </div>
          </div>
        </div>

        <ItemViewSheet
          item={selectedItem}
          entity={currentEntity || null}
          isOpen={isItemSheetOpen}
          onOpenChange={handleCloseItemSheet}
        />
      </div>
    </div>
  );
}
